export const GL = {
    translations: {
        notifications: 'Notificacións',
        markAllAsRead: 'Marcar todo coma lido',
        poweredBy: 'Coa tecnoloxía de',
        settings: 'Axustes',
        noNewNotification: 'Aínda non hai nada novo que ver aquí',
    },
    lang: 'gl',
};
//# sourceMappingURL=gl.js.map